import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard implements CanActivate {
  constructor(
    private router: Router,
    private msalService: MsalService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const isAuthenticated = this.msalService.instance.getAllAccounts().length > 0 &&
                            sessionStorage.getItem('Session_Id');

      if (isAuthenticated) {
        this.router.navigate(['/dashboardpage']);
        return false;
      }
    }
    return true;
  }
}